import { render, staticRenderFns } from "./FormValidationSimple.vue?vue&type=template&id=2225c610"
import script from "./FormValidationSimple.vue?vue&type=script&lang=js"
export * from "./FormValidationSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports